import { API_ENDPOINTS } from '@tsgecart/config';
import { storefrontApiFetch } from '../../../../lib/api/storefront-client.js';
import type { ContactInfo, ContactSubmitInput, ContactSubmitResult } from '../types/contact.js';

export interface FetchOptions {
  signal?: AbortSignal;
}

export async function fetchContactInfo(options: FetchOptions = {}): Promise<ContactInfo> {
  return storefrontApiFetch<ContactInfo>(API_ENDPOINTS.contact, options);
}

export async function submitContactForm(
  input: ContactSubmitInput,
  options: FetchOptions = {},
): Promise<ContactSubmitResult> {
  return storefrontApiFetch<ContactSubmitResult>(API_ENDPOINTS.contact, { ...options, method: 'POST', body: input });
}
